module.exports = __webpack_public_path__ + "img/6138048.796f1349.jpg";